/** Shared provider tags used on the game page (e.g. main nav / physical metrics / data insights). */
export enum GameProviderTagEnum {
	UBITRACK = "UBITRACK",
	BEPRO = "BEPRO",
	SPORTLOGIQ = "SPORTLOGIQ",
}
